import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/organization/offices`;

const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export const fetchOfficeLocations = createAsyncThunk("officeLocations/fetch", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${API_URL}/`, authHeaders());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || null);
  }
});

export const geocodeOfficeAddress = createAsyncThunk("officeLocations/geocode", async (address, thunkAPI) => {
  try {
    const response = await axios.post(`${API_URL}/geocode`, { address }, authHeaders());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || null);
  }
});

export const saveOfficeLocation = createAsyncThunk("officeLocations/save", async ({ id, ...office }, thunkAPI) => {
  try {
    const response = id
      ? await axios.put(`${API_URL}/${id}`, office, authHeaders())
      : await axios.post(`${API_URL}/`, office, authHeaders());
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || null);
  }
});

export const deleteOfficeLocation = createAsyncThunk("officeLocations/delete", async (id, thunkAPI) => {
  try {
    await axios.delete(`${API_URL}/${id}`, authHeaders());
    return id;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || null);
  }
});

const sortByName = (offices) => [...offices].sort((a, b) => a.name.localeCompare(b.name));

const officeLocationsSlice = createSlice({
  name: "officeLocations",
  initialState: { items: [], isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOfficeLocations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOfficeLocations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.items = action.payload;
      })
      .addCase(fetchOfficeLocations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(saveOfficeLocation.fulfilled, (state, action) => {
        state.items = sortByName([...state.items.filter((o) => o.id !== action.payload.id), action.payload]);
      })
      .addCase(deleteOfficeLocation.fulfilled, (state, action) => {
        state.items = state.items.filter((o) => o.id !== action.payload);
      });
  },
});

export default officeLocationsSlice.reducer;
